
export const corrections: Record<string, string> = {
  teh: "the",
  adn: "and",
  recieve: "receive",
  adress: "address",
  definately: "definitely",
  thier: "their",
  becuase: "because",
  seperate: "separate",
  occurrance: "occurrence",
  cmpaign: "campaign",
  campign: "campaign",
  campaing: "campaign",
  campaingn: "campaign",
  campaingns: "campaigns",
  campiagn: "campaign",
  sals: "sales",
  saled: "sales",
  saless: "sales",
  promtion: "promotion",
  promtions: "promotions",
  promtional: "promotional",
  promtionally: "promotionaly",
  customeer: "customer",
  custmoer: "customer",
  custmers: "customers",
  customeers: "customers",
  custmoers: "customers",
  engagment: "engagement",
};

/** Auto-correct helper function */
export function autoCorrectInput(text: string): string {
  return text.replace(/\b(\w+)\b/g, word => {
    const lower = word.toLowerCase();
    return corrections[lower] || word;
  });
}
